export default "__VITE_ASSET__8cc133c1__"